import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  AfterViewInit,
} from '@angular/core';

@Directive({
  selector: '[appStickyButton]',
  standalone: true,
})
export class StickyButtonDirective implements AfterViewInit {
  @Input('appStickyButton') footerSelector!: string;
  public footerElement!: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.footerElement = document.querySelector(
      this.footerSelector
    ) as HTMLElement;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.footerElement || this.footerElement?.parentElement?.classList.contains('hideFooter')) return;
    const footerRect = this.footerElement.getBoundingClientRect();
    const isFooterVisible = footerRect.top < window.innerHeight;

    if (isFooterVisible) {
      this.renderer.addClass(this.el.nativeElement, 'stuck');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'stuck');
    }
  }
}
